import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

import { ArticlesResponse } from '../types';

export * from './monthlyDates';

export const useGetArticles = async (options: AxiosRequestConfig) =>
  axios(options)
    .then((res: AxiosResponse<ArticlesResponse>) => {
      const result = res.data;
      return result;
    })
    .catch((error: AxiosError<{ error: string }>) => {
      // eslint-disable-next-line no-console
      console.log(error);
    });

export const useGetLatestArticles = async ({ offset }: { offset: number }) => {
  const options = {
    method: 'get',
    url: '/wp-json/wp/v2/articles/',
    params: {
      offset,
      posts_per_page: 12,
    },
  };

  return useGetArticles(options);
};

export const useGetCategoryArticles = async ({ offset, id }: { offset: number; id: string }) => {
  const options = {
    method: 'get',
    url: `/wp-json/wp/v2/category/${id}/`,
    params: {
      offset,
      posts_per_page: 12,
    },
  };

  return useGetArticles(options);
};

export const useGetTagArticles = async ({ offset, id }: { offset: number; id: string }) => {
  const options = {
    method: 'get',
    url: `/wp-json/wp/v2/tag/${id}/`,
    params: {
      offset,
      posts_per_page: 12,
    },
  };

  return useGetArticles(options);
};

export const useGetFeaturesArticles = async ({ offset, id }: { offset: number; id: string }) => {
  const options = {
    method: 'get',
    url: `/wp-json/wp/v2/feature/articles/${id}/`,
    headers: { 'X-WP-Nonce': window.tgwRestApi.nonce },
    params: {
      offset,
      posts_per_page: 12,
    },
  };

  return useGetArticles(options);
};

export const useGetFocusArticles = async ({
  offset,
  year,
}: {
  offset: number;
  year: string | null;
}) => {
  const options = {
    method: 'get',
    url: '/wp-json/wp/v2/features/',
    headers: { 'X-WP-Nonce': window.tgwRestApi.nonce },
    params: {
      offset,
      posts_per_page: 12,
      year,
    },
  };

  return useGetArticles(options);
};

export const useGetMonthlyArticles = async ({ offset, id }: { offset: number; id: string }) => {
  const options = {
    method: 'get',
    url: `/wp-json/wp/v2/monthly/articles/${id}/`,
    headers: { 'X-WP-Nonce': window.tgwRestApi.nonce },
    params: {
      offset,
      posts_per_page: 12,
    },
  };

  return useGetArticles(options);
};

export const useGetSearchArticles = async ({
  offset,
  query,
}: {
  offset: number;
  query: string;
}) => {
  const options = {
    method: 'get',
    url: '/wp-json/wp/v2/search/',
    headers: { 'X-WP-Nonce': window.tgwRestApi.nonce },
    params: {
      offset,
      posts_per_page: 12,
      s: query,
    },
  };

  return useGetArticles(options);
};
